import { render, staticRenderFns } from "./AddMaterialDialog.vue?vue&type=template&id=63c8e2f5&scoped=true"
import script from "./AddMaterialDialog.vue?vue&type=script&lang=js"
export * from "./AddMaterialDialog.vue?vue&type=script&lang=js"
import style0 from "./AddMaterialDialog.vue?vue&type=style&index=0&id=63c8e2f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c8e2f5",
  null
  
)

export default component.exports